export const CVALUES = {
    CONTENT_TYPE_JSON: 'application/json;charset=utf-8',
    CONTENT_TYPE_FORM: 'multipart/form-data',
    DEFAULT_PATTERN: '%vehicle_type%_%vehicle_version%.pdx',
    DSACOMPANY: 1,
    VERSION: '202601',
    SVNURL: true,
    LOGIN_URL: 'ddp/oauth2/authorization/keycloak',
    LOGOUT_URL: 'ddp/logout'
};
